<template>
    <b-container fluid class="mb-3">
        <b-row align-v="center" class="header p-2">
            <b-col>
                <b-img :src="logo" height="80%" right rounded></b-img>
            </b-col>
            <b-col cols="4" class="text-center text-light">
                <h1><span class="signoria-regular font-weight-bold">CNAREFE</span></h1>
                Centre National des Retraités de France à l'Étranger
            </b-col>
            <b-col class="text-left">
                <b-button @click="$actions.showFaq($bvModal)" variant="outline-light" size="lg">
                    <b-icon icon="chat-right-quote-fill"></b-icon> Une question ?
                </b-button>
            </b-col>
        </b-row>

        <!-- Intégration de la FAQ-->
        <Faq :target="faqTarget"/>

    </b-container>
</template>

<script>
import Faq from '@/components/Faq'

export default {
    name: 'Header',
    components: {
        Faq
    },
    data() {
        return {
            logo: require('@/assets/logo-assurance-maladie.jpg')
        }
    },
    computed: {
        faqTarget: {
            get() {
                return this.$store.faqTarget
            },
            set(val) {
                this.$store.faqTarget = val;
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@font-face {
    font-family: 'signoria-regular';
    src: local('signoria-regular'), url('../assets/signoria-regular.ttf') format('truetype');
}

.header {
    text-align: center;
    background-color: #0c419a;
}

.signoria-regular {
    font-family: 'signoria-regular';
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue